export interface OrganMapPositionUpdate {
  subsiteId: string;
  positionX: number | null;
  positionY: number | null;
}

type PersistPosition<Update, Result> = (update: Update) => Promise<Result>;

export class OrganMapPositionUpdateQueue<
  Update extends OrganMapPositionUpdate = OrganMapPositionUpdate,
  Result = void
> {
  private readonly tails = new Map<string, Promise<void>>();

  constructor(
    private readonly persistPosition: PersistPosition<Update, Result>
  ) {}

  enqueue(updateRequest: Update): Promise<Result> {
    const previous =
      this.tails.get(updateRequest.subsiteId) || Promise.resolve();
    const update = previous
      .catch(() => undefined)
      .then(() => this.persistPosition(updateRequest));
    const tail = update.then(
      () => undefined,
      () => undefined
    );
    this.tails.set(updateRequest.subsiteId, tail);
    void tail.finally(() => this.removeTail(updateRequest.subsiteId, tail));
    return update;
  }

  private removeTail(subsiteId: string, tail: Promise<void>): void {
    if (this.tails.get(subsiteId) === tail) this.tails.delete(subsiteId);
  }
}
